'use client';
// VX-3 D3 — 흐린 미리보기 위 200ms 페이드인의 «아주 작은» 클라이언트 조각(렌더 0 — null).
//
// 서버 마크업만으로도 선다: 상자 배경(흐린 미리보기) 위에 <img> 가 그려진다. 이 조각은 그 위에 페이드만 얹는다.
//   · 수화 시점에 «아직 안 뜬» 이미지(img.complete === false)만 data-kd-fade="wait"(투명) 로 두고, load/error 에 "in"(200ms).
//   · 이미 뜬 이미지는 건드리지 않는다(깜빡임 0). priority(히어로 첫 이미지)에는 KdMediaFrame 이 이 표식을 달지 않는다(LCP 불간섭).
//   · prefers-reduced-motion 이면 아무것도 하지 않는다(CSS 쪽도 transition 을 끈다).
//   · 문서당 리스너 1개(load 는 버블하지 않아 capture 로 받는다). 인스턴스가 여럿이어도 재설치하지 않는다.
// ⛔ JS 가 꺼져 있거나 이 조각이 실패해도 이미지는 그대로 보인다 — 투명 상태는 «이 코드가» 만들 때만 생긴다.
import { useEffect } from 'react';

const FLAG = '__kdMediaFade';

function arm(): void {
  const list = document.querySelectorAll<HTMLImageElement>('img[data-kd-fade=""]');
  list.forEach((img) => {
    img.dataset.kdFade = img.complete ? 'done' : 'wait';
  });
}

export default function KdMediaFade(): null {
  useEffect(() => {
    try {
      if (typeof window === 'undefined' || !window.matchMedia) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const w = window as unknown as Record<string, unknown>;
      if (!w[FLAG]) {
        w[FLAG] = true;
        const settle = (e: Event) => {
          const t = e.target;
          if (t instanceof HTMLImageElement && t.dataset.kdFade === 'wait') t.dataset.kdFade = 'in';
        };
        document.addEventListener('load', settle, true);
        document.addEventListener('error', settle, true);
      }
      arm();
    } catch {
      /* 페이드는 장식이다 — 실패하면 그냥 보인다 */
    }
  }, []);
  return null;
}
